const months = {
  'months.short.jan': 'jan',
  'months.short.feb': 'feb',
  'months.short.mar': 'mar',
  'months.short.apr': 'apr',
  'months.short.may': 'may',
  'months.short.jun': 'jun',
  'months.short.jul': 'jul',
  'months.short.aug': 'aug',
  'months.short.sep': 'sep',
  'months.short.oct': 'oct',
  'months.short.nov': 'nov',
  'months.short.dec': 'dec',
};

export default months;
